// StationsField.js

import { Box, Text, Header, CheckBox, grommet, Grommet, Button, Tip} from "grommet";
import { useState, useEffect} from "react";
import { deepMerge } from "grommet/utils";
import { maxVinesOnRow, maxVinesOnStation, maxRowsOnField } from "../Utils/Utils";
import WarningPopupWindow from "../Base components/WarningPopupWindow";
import { Trash } from "grommet-icons";

const customTheme = deepMerge(grommet, {
    global: {
        colors: {
            brand: 'neutral-3',
            text: "neutral-3",
            border: "neutral-3",
            selected: "light-4",
        },    
    },
    box: {
        extend: ({ hoverIndicator }) => {
            if (hoverIndicator) {            
                return `
                    &:hover {
                        cursor: ${"pointer"};
                    }
                    `;
            }
        }
    },
    checkBox: {
        size: {
            width: "15px",
            height: "15px"
        }
    }
});

const StationsField = (props) => {
    const {occupiedLocations, newPlants, rowNum, field, stationName,
        onChangeStationToCol, onChangeStationFromCol, newStationNum, 
        onDeleteScion, onInsertScion, shiftLeft, shiftRight} = props;

    // console.log('In StationsField props obj:', props);
    // console.log("occupiedLocations >> >>> ", occupiedLocations);
    // console.log("newPlants >> >>> ", newPlants);   
    // console.log("newStationNum >> >>> ", newStationNum);  

    const [locations, setLocations] = useState([]);    
   //  const [displayFromCol, setDisplayFromCol] = useState(newPlants[0].Column <= field.VinesOnRow/2 ? 0 : field.VinesOnRow/2);   

    const [displayFromCol, setDisplayFromCol] = useState((newPlants[0].Column <= 40 || newPlants[0].Row ===  field.RowTo) ? 0 : newPlants[0].Column <= 80 ? 40 : 80);  
    const [displayFromRow, setDisplayFromRow] = useState(rowNum);   

    let maxRow = field.VinesOnRow/maxVinesOnStation;
    // if (rowNum  === field.FieldNum + maxRowsOnField)
    //     maxRow /= 2;

    // console.log(' maxRow >> ', maxRow);
    // const stationForNewLocation = newPlants[0].StationNum;
    //const stationForNewLocation = newStationNum;

    const [showWarning, setShowWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');  

    const findOccupiedElementByRowCol = (row, col) => {
        if (occupiedLocations !== null && occupiedLocations !== undefined && occupiedLocations.length > 0) {
            return occupiedLocations.find((element) => {
                return (element.ScionRow === row && element.ScionColumn === col 
                    && element.IsSeedling === 0 && element.IsUprooted === 0 && element.FreeLocation === 'No');
            });
        }
    };

    const findUprootedElementByRowCol = (row, col) => {
        if (occupiedLocations !== null && occupiedLocations !== undefined && occupiedLocations.length > 0) {
            return occupiedLocations.find((element) => {
                return (element.ScionRow === row && element.ScionColumn === col 
                    && element.IsUprooted === 1 && element.FreeLocation === 'No');
            });
        }
    };    

    const findSeedlingByRowCol = (row, col) => {
        if (occupiedLocations !== null && occupiedLocations !== undefined && occupiedLocations.length > 0) {
            return occupiedLocations.find((element) => {
                return (element.ScionRow === row && element.ScionColumn === col 
                    && element.IsSeedling === 1 && element.FreeLocation === 'No');
            });
        }
    }; 

    const getLocationByRowCol = (arr, row, col) => {
        if (arr !== null && arr !== undefined && arr.length > 0) {
            return arr.find((element) => {
                return (element.Row === row && element.Column === col);
            });
        }
    };

    // operation is valid, only if the element is at the beginning or end of the planned array
    // and the array length is not greater than the maximum number of elements per station
    const isValidChange_Old = (el, value) => {
        // console.log("In isValidChange value >>  ", value); 
        // console.log("In isValidChange el >> ", el); 
        let first = newPlants.slice(0,1).pop();
        // console.log("In isValidChange newPlants >> first ", first); 
        let last = newPlants.slice(-1).pop();
        // console.log("In isValidChange newPlants >> last ", last);  

        if (value === false) {
            if (first.Row === el.RowOnField && first.Column === el.ColOnField) {
                onChangeStationFromCol(el.ColOnField+1, el.RowOnField, newStationNum);
                return true;
            }
            if (last.Row === el.RowOnField && last.Column === el.ColOnField) {
                onChangeStationToCol(el.ColOnField-1, el.RowOnField, newStationNum);  
                return true;              
            } 
            onDeleteScion(el);  
            return true;          
        }
        else {
            if (first.Row === el.RowOnField && (first.Column - el.ColOnField === 1)) {
                onChangeStationFromCol(el.ColOnField, el.RowOnField, newStationNum);
                return true;
            }
            if (last.Row === el.RowOnField && el.ColOnField - last.Column === 1) {
                onChangeStationToCol(el.ColOnField, el.RowOnField, newStationNum);
                return true;
            }

        }
        return false
    }

    
    // operation is valid, only if the element is at the beginning or end of the planned array
    // and the array length is not greater than the maximum number of elements per station
    const isValidChange = (el, value) => {
        // // console.log("In isValidChange value >>  ", value); 
        // // console.log("In isValidChange el >> ", el); 

        // remove from list
        if (value === false) {
            onDeleteScion(el);  
            return true;          
        }
        else {  
            // add to list      
            let first = newPlants.slice(0,1).pop();
            // console.log("In isValidChange newPlants >> first ", first); 
            let last = newPlants.slice(-1).pop();
            // console.log("In isValidChange newPlants >> last ", last);  

            if ((first.Row === el.RowOnField && first.Column < el.ColOnField) && 
                    (last.Row === el.RowOnField && last.Column > el.ColOnField)) {
                onInsertScion(el); 
                return true;
            }
            else {
                if (first.Row === el.RowOnField && (first.Column - el.ColOnField === 1)) {
                    shiftLeft(el); 
                    return true;
                }

                if (last.Row === el.RowOnField && el.ColOnField - last.Column === 1) {
                    shiftRight(el); 
                    return true;
                }
            }
            return false;
        }
    }



    const onCheckedChange = (item, value) => {
        let change = isValidChange(item, value);
        if (!change) {
            //alert('operation Not valid');
            setWarningMessage('Operation Not valid');
            setShowWarning(true);
            return;
        }
        // console.log("change >> ", change); 
    };

    const closeWarning = () => {
        setShowWarning(false);
        setWarningMessage('');
    };

    const drawField = () => {
        let values = [];  
        let key = 0;
        // console.log('In drawField maxRow >> ', maxRow);
        // console.log('In reDrawField displayFromCol >> ', displayFromCol);
        let colOnField = displayFromCol;
        const rowsToDisplay = maxRow; // number of lines to display for one row equals to 10
        let rowNumToDisplay = displayFromRow; // number of row, for example 101

        // console.log('In drawField rowsToDisplay >> ', rowsToDisplay);
        // console.log('In drawField rowNumToDisplay >> ', rowNumToDisplay);
        // console.log('In drawField maxVinesOnStation >> ', maxVinesOnStation); // always equals 10 vines in a row
        // console.log('In drawField newPlants[0].Column >> ', newPlants[0].Column );
        // console.log('In drawField maxRowsOnField +100 >> ',  maxRowsOnField +100);  
        // console.log('In drawField newPlants >> ', newPlants);     

        for (let r = 1; r <= rowsToDisplay && rowNumToDisplay <= field.RowTo; r++) {
            for (let c = 1; c <= maxVinesOnStation; c++) {

                ++colOnField;
                let occupied = findOccupiedElementByRowCol( rowNumToDisplay, colOnField);
                let uprooted = findUprootedElementByRowCol( rowNumToDisplay, colOnField);
                let seedling = findSeedlingByRowCol( rowNumToDisplay, colOnField);
                let planned = getLocationByRowCol( newPlants, rowNumToDisplay, colOnField);


                if (occupied !== undefined && occupied !== null)                    
                    values.push({Id: ++key, Row: r, RowOnField:  occupied.ScionRow, Column: c, ColOnField: occupied.ScionColumn, Occupied: 1, StationNum: occupied.StationNum, StationName: occupied.StationName, Uprooted: 0, FreeLocation: 'No', IsSeedling: 0, Checked: false});
                else if (uprooted !== undefined && uprooted !== null)                    
                    values.push({Id: ++key, Row: r, RowOnField:  uprooted.ScionRow, Column: c, ColOnField: uprooted.ScionColumn, Occupied: 1, StationNum: uprooted.StationNum, StationName: uprooted.StationName, Uprooted: 1, FreeLocation: 'No', IsSeedling: 0, Checked: false});
                else if (seedling !== undefined && seedling !== null)                    
                    values.push({Id: ++key, Row: r, RowOnField:  seedling.ScionRow, Column: c, ColOnField: seedling.ScionColumn, Occupied: 1, StationNum: seedling.StationNum, StationName: seedling.StationName, Uprooted: seedling.Uprooted, FreeLocation: 'No', IsSeedling: 1, Checked: false});
                else if (planned !== undefined && planned !== null)
                    values.push({Id: ++key, Row: r, RowOnField: planned.Row, Column: c, ColOnField: planned.Column, Occupied: 2, StationNum: planned.StationNum, StationName: props.stationName, Uprooted: 0, FreeLocation: 'Yes', IsSeedling: 0, Checked: true});
                else
                    values.push({Id: ++key, Row: r, RowOnField: rowNumToDisplay, Column: c, ColOnField: colOnField, Occupied: 0, StationNum: 0, StationName: '', Uprooted: 0, FreeLocation: 'Yes', IsSeedling: 0, Checked: false});

                    if (colOnField === field.VinesOnRow) {
                        colOnField = 0 ; 
                        rowNumToDisplay++; 
                    }          
            }
        }

        setLocations(values);
        // console.log('In drawField values >> ', values);
    }

    useEffect(() => {
        setDisplayFromRow(rowNum);
        setDisplayFromCol((newPlants[0].Column <= 40 || newPlants[0].Row === field.RowTo) ? 0 : newPlants[0].Column <= 80 ? 40 : 80);  
    },[rowNum]); 

    useEffect(() => {
        if (displayFromRow !== '') {
            if (newPlants[0].Row === field.RowTo) {
                setDisplayFromCol(0);
            }
            drawField();
        }
    },[newPlants, displayFromCol, displayFromRow, stationName]);

    
    const forward = () => {   
        // console.log('displayFromRow >> ', displayFromRow);
        // console.log('field.RowTo >> ', field.RowTo);

        // at the end of the field there is no place to move
        if (displayFromRow === field.RowTo) {
            setDisplayFromCol(0);
            return;
        }
        // console.log('displayFromCol >> ', displayFromCol)
        setDisplayFromCol((displayFromCol + 40) % field.VinesOnRow);
         if ((displayFromCol + 40) === field.VinesOnRow) {
            // console.log('displayFromRow+1 >> ', displayFromRow+1)
            if (displayFromRow+1 <= field.RowTo)
                setDisplayFromRow(displayFromRow+1);
        }
             
    }

    const back = () => {
        // at the beginning of the field there is no place to move
        if (displayFromRow === field.RowFrom) {
            setDisplayFromCol(0);
            return;
        }

        setDisplayFromCol(displayFromCol === 0 ? 40 : 0);  
        if ((displayFromCol - 40) < 0) {             
            // console.log('field.FieldNum + 1 >> ', field.FieldNum + 1)
            if (displayFromRow-1 >= field.RowFrom)
                setDisplayFromRow(displayFromRow-1);
        }
    }

    const DrawItem = (item) =>
    {
        // console.log('item >> ', item);

        /*  if scion still not uprooted or was uprooted less than a year ago 
          then 'FreeLocation' = 'No', otherwise 'FreeLocation' = 'Yes' **/

        let bg = (item.Occupied === 1 && item.Uprooted === 1 && item.FreeLocation === 'No') ? "#A2423D" // uprooted less than a year ago
        : (item.Occupied === 1 && item.Uprooted === 0) ? "#ff4040"
        : (item.Occupied === 2) ? "#ffff40"
        : (item.IsSeedling === 1) ? "#80acbd" // seedlings, only if none of the above applies
        : "#bed3be";
    

        let columnNumColor = (item.Occupied !== 1) ? "green" : "yellow";
        let stationNumColor = (item.Occupied === 1) ? "white" : "red";


        return(
            <Tip  key={Math.random(100)}
                content={<Box style={{fontWeight: "bold", background: "rgba(204, 204, 204, .6)", padding: "5px",  borderRadius: "8px"}}>
                {item.StationName}
                </Box>}
                plain
            >
            <Box margin={"xxsmall"} pad={"xxsmall"} 
                width={{ width: '60px', min: '60px' }}
                height={{ height: '50px',  min: '50px' }}
                align="center"
                background={bg}
                style={{position:"relative" }}
                border
            >
                <Box style={{position:"absolute", left: "3px", top: "3px"}} >
                    {( item.Occupied !== 1) && (
                        (item.Occupied === 2) ? <Trash color="red" size="small"                        
                            onClick={() => onCheckedChange(item, false)} 
                        />
                        :
                        <CheckBox // value={1} 
                            checked={item.Checked} 
                            onChange={(event) =>  onCheckedChange(item, event.target.checked)}
                        /> )
                    }
                </Box> 
                <Box style={{position:"absolute", right: "3px", top: "3px"}} hoverIndicator>    
                    {/* <Text size="small" color={stationNumColor}  weight="bold">{item.StationNum > 0 ? item.StationNum : ''}</Text> */}
                </Box>
                <Box style={{position:"absolute", left: "7px", bottom: "1px"}} > 
                    <Text size="small" color={columnNumColor}>{item.RowOnField }</Text>
                    </Box>
                <Box style={{position:"absolute", right: "3px", bottom: "1px"}} > 
                    <Text size="small" color={columnNumColor}>{item.ColOnField }</Text>          
                </Box>                
            </Box>
            </Tip>
        );
    }  

    const DrawRow = (rowNum) => {
        const row = [];
        let item = undefined;
        for (let i = 1; i <= maxVinesOnStation; i++) {
            item = getLocationByRowCol(locations, rowNum, i); 
            if (item !== undefined)           
                row.push( DrawItem(item) );
        }
        return(row);
    }

    const DrawField = () => {
        const field = [];
        let bg = '';
        for (let i = 1; i <= maxRow; i++) {
                if (i % 2 === 0)
                bg = "#Cbe0cb";
            else
                bg = "#bed3be";

            field.push(
                <Box  key={i * Math.random(100)}
                    direction="row-responsive"
                    flex={true}
                    wrap={true}
                    pad={"xxsmall"}
                    background={bg}
                >
                    {DrawRow(i)}
                </Box>
            );
        }
        return field;
    }

    const style = {
        border: "2px solid",       
    //    margin: "10px",
    };

    return (
        <Grommet theme={customTheme} > 
            <Box  style={style}  pad="xsmall"  background="light-3" >
                <Header margin="none" background="light-4" pad="xxsmall" height="xxsmall" justify="around" >
                    <Text color="brand" size="large"  align="center" background="light-4">
                        <strong>Planning stations shown in the field</strong>
                    </Text>
                </Header>

                {showWarning && (
                    <WarningPopupWindow msg={warningMessage} close={closeWarning}/>
                )}
                <Box height= '350px' align="center"  border>

                    <Box   width="100%"> 
                        <Box margin="xxsmall"  align="center" direction="row-responsive" justify="around" >
                            <Box pad={{horizontal: "xsmall"}} direction="column" >
                                <Box >
                                    <Text weight="bold" margin={{vertical: "xxsmall"}} size="medium" > Colors: </Text>
                                </Box>

                                <Box direction="row-responsive"  >
                                    <Box>
                                        <Box direction="row"  align="center">
                                            <Box pad="xxsmall"  width= "15px" height= "15px" background="#ff4040" margin="xxsmall" align="center" round={true}>
                                            </Box>
                                            <Text  margin={{horizontal: "xsmall"}} size="16px" > occupied </Text>                         
                                        </Box>                    

                                        <Box direction="row"  align="center">
                                            <Box pad="xxsmall"  width= "15px" height= "15px" background="#A2423D" margin="xxsmall" align="center" round={true}>
                                            </Box>
                                            <Text  margin={{horizontal: "xsmall"}} size="16px" > uprooted </Text>                         
                                        </Box> 
                                    </Box>
                                    <Box>
                                        <Box direction="row" align="center" >
                                            <Box pad="xxsmall"  width= "15px" height= "15px" background="#ffff40" margin="xxsmall" align="center" round={true}>
                                            </Box>
                                            <Text  margin={{horizontal: "xsmall"}} size="16px" > planned </Text>                         
                                        </Box>   

                                        <Box direction="row" align="center" >
                                            <Box pad="xxsmall" width= "15px" height= "15px" background="#bed3be" margin="xxsmall" align="center" round={true}>
                                            </Box>                    
                                            <Text  margin={{horizontal: "xsmall"}} size="16px" > empty </Text>                         
                                        </Box> 
                                    </Box>
                                        
  
                                                    
                                </Box>

                                <Box>
                                    <Box direction="row" align="center" >
                                        <Box pad="xxsmall"  width= "15px" height= "15px" background="#80acbd" margin="xxsmall" align="center" round={true}>
                                        </Box>
                                        <Text  margin={{horizontal: "xsmall"}} size="16px" > seedlings from sukka </Text>                         
                                    </Box>   
                                </Box>
                            </Box> 

                            <Box pad={{horizontal: "xsmall"}} direction="column" >
                                <Box >
                                    <Text weight="bold" margin={{vertical: "xxsmall"}} size="medium" > Numbers: </Text>
                                </Box>
                                <Box pad={{horizontal: "xsmall"}} direction="row" width="200px" >
                                    <Box direction="column"  >
                                        <Box margin={"xxsmall"} pad={"xxsmall"} background="#bed3be"> 
                                            <Box margin={"xsmall"} pad={"xsmall"} 
                                                width={{ width: '60px', min: '60px' }}
                                                height={{ height: '40px',  min: '40px' }}
                                                align="center"
                                                background="#bed3be"
                                                style={{position:"relative" }}
                                                border
                                            >
                                                <Box style={{position:"absolute", left: "3px", top: "3px"}} >
                                                </Box> 
                                                <Box style={{position:"absolute", right: "7px", top: "1px"}} >           
                                                    {/* <Text color="green">s</Text> */}
                                                </Box>
                                                <Box style={{position:"absolute", left: "7px", bottom: "3px"}} > 
                                                    <Text size="small" color="green"  weight="bold">r</Text>
                                                </Box>
                                                <Box style={{position:"absolute", right: "7px", bottom: "3px"}} >           
                                                    <Text color="green">v</Text>
                                                </Box>                
                                            </Box>              
                                        </Box>
                                    </Box>

                                    <Box direction="column"  >
                                        <Box direction="row" >
                                            {/* <Text  margin={{horizontal: "xsmall"}} size="medium" > s - station </Text>                          */}
                                        </Box>                    

                                        <Box direction="row" align="center" >
                                            <Text  margin={{horizontal: "xsmall"}} size="medium" > r - row </Text>                         
                                        </Box>   

                                        <Box direction="row" align="center" >                  
                                            <Text  margin={{horizontal: "xsmall"}} size="medium" > v - vine </Text>                         
                                        </Box>                  
                                    </Box>
                                </Box>
                            </Box> 

                            <Box align="center"  gap="small" pad="small">
                                <Box >
                                    {/* <Button primary style={{color: "#ffffff"}} label="Close" onClick={props.onClose} /> */}
                                </Box>
                                <Box direction="row" justify="between" margin={{ horizontal: "xsmall" }}  background='light-1'  width="90px" >
                                    <Box  hoverIndicator >
                                        <Button primary style={{color: "#ffffff", width: "40px", height: "30px", padding:"0 0 8px 0", borderRadius: "15px 0px 0px 15px", fontSize: "24px", fontWeight: "bold"}} label="<" onClick={() => back()}/>
                                    </Box>
                                    <Box  hoverIndicator >
                                        <Button primary style={{color: "#ffffff", width: "40px", height: "30px", padding:"0 0 8px 0", borderRadius: "0px 15px 15px 0px", fontSize: "24px", fontWeight: "bold"}} label=">" onClick={() => forward()} />
                                    </Box>
                                </Box>
                            </Box> 
                        </Box>          
                    </Box> 
                    <Box flex={true} align='center' background='light-1' overflow='auto' border>
                        <Box flex={false} background='white'>
                        {(locations.length > 1) &&
                            DrawField() 
                        }  
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Grommet> 
    );
};

export default StationsField;
